import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import ApplianceRedeploySvg from '../../../assets/icons/app/appliance-redeploy.svg?raw';

export const ApplianceRedeployIcon = (props) => <CustomSVG svg={ApplianceRedeploySvg} preserveColors appIconSmall {...props} />;
